import React from 'react'
import { SideNavigation, StudentNavbar, UserDashboardHeader } from '../components'
import { TextInput, Button } from 'flowbite-react';
import Alert from '@mui/material/Alert';

const Teacher = () => {
  return (
    <div className="flex flex-col w-[100%] h-screen">
        <StudentNavbar/>
        <UserDashboardHeader />
        <div className="w-full flex py-10">
            <SideNavigation />
            <div className="w-[75%] px-10 border-l border-[#fdfdfd]">
                <div className="pb-4">
                    <Alert severity="info">This page is for demo purposes only. Updates coming soon!</Alert>
                </div>
                <p className="text-white text-5xl pb-4 font-thin">My Teachers</p>
                
                <div className="grid grid-cols-3">
                    <div className="flex flex-col w-full">
                        <p className="text-white text-xl   pt-5 pb-2">Join a Classroom</p>
                        <Button className="hover:cursor-pointer text-white rounded-md py-2 w-[35%]">Enter Code</Button>
                    </div>
                    <div className="flex flex-col border-b-[1px] w-[70%] col-span-2 ml-[20%]">
                        <p className="text-white text-xl   pt-5">Your Teachers</p>
                        <p className="text-white py-4 font-thin">You have no teachers currently - Feature coming soon!</p>
                    </div>
                    <div className="col-span-3">
                        <p className="text-white text-xl   pt-20 pb-2">Add a Teacher</p>
                        <p className="text-white font-thin">Enter your teacher's email address:</p>
                        <div className="flex items-center">
                            <TextInput style={{ height: '40px', width:'300px', borderTopRightRadius: '0', borderBottomRightRadius: '0' }} id="input-gray" placeholder="Input email" />
                            <Button className="h-[40px] rounded-md rounded-l-none">Add Teacher</Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Teacher